export const environment = {
  production: true,
  // apiUrl: 'https://6x6hep4ey9.execute-api.eu-central-1.amazonaws.com/production',
  apiUrl: 'https://backend-io.awb.inspera.com',
  currentUrl: 'https://app-originality.awb.inspera.com/', //'https://app-originality.inspera.com/',
  linkedInKey: '8680zqbivxc0lo',
  // externalReport: 'https://originality-report.inspera.com/',
  externalReport: 'http://localhost:4300/',
  externalCodeReport: 'https://originality-report.awb.inspera.com/',
  pilotApp: false
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.